import { render, staticRenderFns } from "./NeoparentDashboardLayout.vue?vue&type=template&id=467c0f46"
import script from "./NeoparentDashboardLayout.vue?vue&type=script&lang=js"
export * from "./NeoparentDashboardLayout.vue?vue&type=script&lang=js"
import style0 from "./NeoparentDashboardLayout.vue?vue&type=style&index=0&id=467c0f46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports